import React, { useContext, useState } from "react";
import CommonModal from "../CommonModal";
import Button from "../../Elements/Button";
import { networkService } from "../../config/axios";
import UserInfoContext from "../../../utis/userInfoContext";

const BulkUserDomainsModal = ({ openModal, closeModal, userIds }) => {
    const { setShowNotifications } = useContext(UserInfoContext);

    const [domainSearch, setDomainSearch] = useState("");
    const [domainResults, setDomainResults] = useState([]);
    const [showResults, setShowResults] = useState(false);
    const [selectedDomainId, setSelectedDomainId] = useState(null);
    const [isDefault, setIsDefault] = useState(false);

    const searchDomains = async (value) => {
        if (!value || value.length < 2) {
            setDomainResults([]);
            return;
        }

        const res = await networkService(
            `/admin/master_domains.json?query=${value}`,
            "GET"
        );

        setDomainResults(res?.data?.master_domains || []);
    };

    const handleSubmit = async () => {
        try {
            await networkService(
                "/admin/user_domains/bulk_assign",
                "POST",
                {
                    user_ids: userIds,
                    master_domain_id: selectedDomainId,
                    domain_name: selectedDomainId ? null : domainSearch.trim(),
                    default: isDefault,
                }
            );

            setShowNotifications({
                showToast: true,
                toastType: "success",
                toastMessage: "Domain assigned to selected users",
            });

            closeModal();
        } catch (error) {
            setShowNotifications({
                showToast: true,
                toastType: "danger",
                toastMessage:
                    error?.response?.data?.errors?.join(", ") ||
                    "Something went wrong",
            });
        }
    };

    return (
        <CommonModal
            title={`Assign Domain to ${userIds.length} Users`}
            modalStatus={openModal}
            changeActiveStatus={closeModal}
            centered
        >
            <div className="card p-3">
                {/* DOMAIN AUTOCOMPLETE */}
                <div className="position-relative mb-3">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Enter domain name (example.com)"
                        value={domainSearch}
                        onChange={(e) => {
                            const value = e.target.value;
                            setDomainSearch(value);
                            setSelectedDomainId(null);
                            setShowResults(true);
                            searchDomains(value);
                        }}
                        onBlur={() => setTimeout(() => setShowResults(false), 200)}
                    />

                    {showResults && domainResults.length > 0 && (
                        <ul className="list-group position-absolute w-100 z-3">
                            {domainResults.map((domain) => (
                                <li
                                    key={domain.id}
                                    className="list-group-item list-group-item-action cursor-pointer"
                                    onClick={() => {
                                        setDomainSearch(domain.name);
                                        setSelectedDomainId(domain.id);
                                        setShowResults(false);
                                    }}
                                >
                                    {domain.name}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>

                <label className="d-block mb-3">
                    <input
                        type="checkbox"
                        checked={isDefault}
                        onChange={() => setIsDefault(!isDefault)}
                    />{" "}
                    Default Domain
                </label>

                <div className="d-flex gap-2">
                    <Button
                        classList="alert"
                        text="Cancel"
                        onClick={closeModal}
                    />
                    <Button
                        classList="success"
                        text="Assign to All Users"
                        onClick={handleSubmit}
                        disabled={!domainSearch.trim()}
                    />
                </div>
            </div>
        </CommonModal>
    );
};

export default BulkUserDomainsModal;
